import { render, staticRenderFns } from "./person-form.vue?vue&type=template&id=444e8756&"
import script from "./person-form.vue?vue&type=script&lang=js&"
export * from "./person-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports